import {
  ExpenseAndIncomeCategoryResponse,
  CreateExpenseAndIncomeCategoryFormType,
  CreateExpenseAndIncomeCategoryResponse,
  DeleteExpenseAndIncomeCategoryRequestBody,
  DeleteExpenseAndIncomeCategoryResponse,
  EditExpenseAndIncomeCategoryFormType,
  EditExpenseAndIncomeCategoryResponse,
  CreateExpenseAndIncomeSubCategoryFormType,
  CreateExpenseAndIncomeSubCategoryResponse,
  EditExpenseAndIncomeSubCategoryFormType,
  EditExpenseAndIncomeSubCategoryResponse,
  DeleteExpenseAndIncomeSubCategoryRequestBody,
  DeleteExpenseAndIncomeSubCategoryResponse,
  CreateExpenseAndIncomeTypeFormType,
  CreateExpenseAndIncomeTypeResponse,
  EditExpenseAndIncomeTypeFormType,
  EditExpenseAndIncomeTypeResponse,
  DeleteExpenseAndIncomeTypeRequestBody,
  DeleteExpenseAndIncomeTypeResponse,
  ExpenseAndIncomeCategoryParams,
} from "src/pages/MasterData/ExpenseAndIncomeCategory/api/interfaces";
import API from ".";

const featureApiRoute = "/expense-and-incomes";

export const getExpenseAndIncomeCategory = async ({
  type,
}: ExpenseAndIncomeCategoryParams): Promise<ExpenseAndIncomeCategoryResponse> => {
  const response = await API.get<ExpenseAndIncomeCategoryResponse>(
    featureApiRoute,
    {
      params: {
        ...(type ? { type } : {}),
      },
    }
  );

  return response.data;
};

export const createExpenseAndIncomeCategory = async (
  form: CreateExpenseAndIncomeCategoryFormType
): Promise<CreateExpenseAndIncomeCategoryResponse> => {
  const requestBody = {
    expense_and_income: {
      name: form.name,
      hex: form.color,
    },
  };

  const response = await API.post<CreateExpenseAndIncomeCategoryResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const editExpenseAndIncomeCategory = async ({
  id,
  ...form
}: EditExpenseAndIncomeCategoryFormType): Promise<EditExpenseAndIncomeCategoryResponse> => {
  const requestBody = {
    id,
    name: form.name,
    hex: form.color,
  };

  const response = await API.put<EditExpenseAndIncomeCategoryResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const deleteExpenseAndIncomeCategory = async ({
  id,
}: DeleteExpenseAndIncomeCategoryRequestBody): Promise<DeleteExpenseAndIncomeCategoryResponse> => {
  const requestBody = {
    id,
  };
  const response = await API.delete<DeleteExpenseAndIncomeCategoryResponse>(
    featureApiRoute,
    {
      data: requestBody,
    }
  );

  return response.data;
};

export const createExpenseAndIncomeSubCategory = async (
  form: CreateExpenseAndIncomeSubCategoryFormType
): Promise<CreateExpenseAndIncomeSubCategoryResponse> => {
  const requestBody = {
    expense_and_income_category: {
      expense_and_income_id: form.expenseAndIncomeCategoryId,
      name: form.name,
    },
  };

  const response = await API.post<CreateExpenseAndIncomeSubCategoryResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const editExpenseAndIncomeSubCategory = async ({
  id,
  ...form
}: EditExpenseAndIncomeSubCategoryFormType): Promise<EditExpenseAndIncomeSubCategoryResponse> => {
  const requestBody = {
    category_id: form.expenseAndIncomeCategoryId,
    name: form.name,
  };

  const response = await API.put<EditExpenseAndIncomeSubCategoryResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const deleteExpenseAndIncomeSubCategory = async ({
  id,
}: DeleteExpenseAndIncomeSubCategoryRequestBody): Promise<DeleteExpenseAndIncomeSubCategoryResponse> => {
  const requestBody = {
    category_id: id,
  };
  const response = await API.delete<DeleteExpenseAndIncomeCategoryResponse>(
    featureApiRoute,
    {
      data: requestBody,
    }
  );

  return response.data;
};

export const createExpenseAndIncomeType = async (
  form: CreateExpenseAndIncomeTypeFormType
): Promise<CreateExpenseAndIncomeTypeResponse> => {
  const requestBody = {
    expense_and_income_category_item: {
      expense_and_income_category_id: form.expenseAndIncomeSubCategoryId,
      name: form.name,
      hex: form.color,
      type: form.type,
    },
  };

  const response = await API.post<CreateExpenseAndIncomeTypeResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const editExpenseAndIncomeType = async ({
  id,
  ...form
}: EditExpenseAndIncomeTypeFormType): Promise<EditExpenseAndIncomeTypeResponse> => {
  const requestBody = {
    item_id: form.expenseAndIncomeSubCategoryId,
    name: form.name,
    hex: form.color,
    type: form.type,
  };

  const response = await API.put<EditExpenseAndIncomeTypeResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const deleteExpenseAndIncomeType = async ({
  id,
}: DeleteExpenseAndIncomeTypeRequestBody): Promise<DeleteExpenseAndIncomeTypeResponse> => {
  const requestBody = {
    item_id: id,
  };
  const response = await API.delete<DeleteExpenseAndIncomeCategoryResponse>(
    featureApiRoute,
    {
      data: requestBody,
    }
  );

  return response.data;
};
